import type { Dictionary } from "./it";

export const es: Dictionary = {
  common: {
    appName: "Eligo",
    next: "Siguiente",
    back: "Atras",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Guardar",
    close: "Cerrar",
    yes: "Si",
    no: "No",
    required: "Campo obligatorio",
    select: "Seleccionar",
    loading: "Cargando...",
    error: "Error",
    eligible: "Elegible",
    notEligible: "No elegible",
    inProgress: "En curso",
    info: "Info",
    skipToContent: "Ir al contenido",
    open: "Abrir",
    theme: "Tema",
    language: "Idioma",
    of: "de",
  },
  nav: {
    home: "Inicio",
    new: "Nuevo",
    trials: "Ensayos",
    saved: "Enviados",
    assistant: "Chat",
  },
  assistant: {
    title: "Asistente de protocolos",
    subtitle: "Pregunta sobre los protocolos de los estudios cargados.",
    documents: "Documentos",
    uploadCta: "Subir PDF de los protocolos",
    dropHint: "Arrastra aquí o toca para seleccionar (PDF)",
    askPlaceholder: "Haz una pregunta sobre los protocolos...",
    send: "Enviar",
    thinking: "Leyendo los protocolos...",
    noProtocols: "Sube al menos un PDF para empezar.",
    emptyReady: "Haz una pregunta: responderé según los protocolos cargados.",
    dontKnow: "No encuentro esta información en los protocolos cargados.",
    sources: "Fuentes",
    errorGeneric: "Error al contactar con el asistente",
    statusExtracting: "Extrayendo...",
    statusIndexing: "Indexando...",
    statusReady: "Listo",
    statusError: "Error",
    removeDoc: "Eliminar documento",
    clearChat: "Borrar conversación",
    loadedProtocols: "Protocolos",
    kbEmpty: "Aún no hay protocolos disponibles.",
    knowsProtocols: "Conoce los protocolos cargados",
  },
  kbAdmin: {
    title: "Gestión de protocolos",
    subtitle: "Sube los PDF, genera la base de conocimiento y publícala.",
    export: "Exportar base de conocimiento",
    step1: "Sube los PDF de los protocolos arriba y espera el estado 'Listo'.",
    step2: "Pulsa 'Exportar base de conocimiento': se descarga el archivo protocols-index.json.",
    step3: "En GitHub, sube ese archivo a la carpeta public/ (sobrescribiendo) y haz commit: el sitio se actualiza solo.",
  },
  landing: {
    tagline: "Asignacion de paciente a ensayos clinicos - agudo, hemorragico y post-agudo.",
    heroTitle: "Asigna un paciente\na un ensayo.",
    newPatient: "Nuevo paciente",
    newPatientDesc: "Comprueba la elegibilidad en todos los ensayos",
    assistantHeroTitle: "Tu conocimiento de\nlos ensayos, al instante.",
    askCta: "Pregunta sobre los protocolos...",
    suggestions: ["Ensayos activos", "Criterios de inclusion", "Ventanas temporales"],
    inProgressTitle: "Paciente en curso",
    pastPatients: "Pacientes enviados",
    inProgressSubtitle: "Recuperado de localStorage",
    discard: "Descartar",
    resume: "Continuar",
    catalogTitle: "Catalogo de ensayos",
    catalogSubtitle: "Explora los criterios de todos los ensayos activos",
    catalogDesc: "Consulta sin paciente, solo de referencia.",
    patientId: "ID",
    age: "Edad",
    nihss: "NIHSS",
    ltsw: "LTSW",
  },
  workflow: {
    title: "Que quieres hacer?",
    subtitle: "Selecciona el flujo para comenzar.",
    eligibilityTitle: "Evaluacion de elegibilidad",
    eligibilityDesc: "Anamnesis + imagen guiada para identificar ensayos adecuados.",
    trialsTitle: "Info de ensayos",
    trialsDesc: "Catalogo con criterios de inclusion/exclusion.",
    quickTitle: "Paciente rapido",
    quickDesc: "Entrada rapida para paciente ya reclutado.",
  },
  trials: {
    title: "Ensayos clinicos",
    countSuffix: "totales",
    searchLabel: "Buscar",
    searchPlaceholder: "nombre, categoria, intervencion...",
    filterAll: "Todos",
    filterIschemic: "Isquemico",
    filterHemorrhagic: "Hemorragico",
    filterPostAcute: "Post-agudo",
    empty: "Ningun ensayo coincide con los filtros.",
    window: "Ventana",
    backToCatalog: "Catalogo",
    keyCriteria: "Criterios clave",
    imaging: "Imagen",
    intervention: "Intervencion",
    treatment: "Tratamiento",
    notes: "Notas",
    visits: "Visitas de seguimiento",
    openRandomizer: "Abrir randomizador",
    fieldWindow: "Ventana",
    fieldAge: "Edad",
    fieldMrs: "pre-mRS",
    fieldNihss: "NIHSS",
    fieldAspects: "ASPECTS",
    thrombolytic: "Trombolitico",
    thrombectomy: "Trombectomia",
    preEvtLabs: "Labs pre-EVT",
    consent: "Consentimiento",
    notFoundTitle: "Ensayo no encontrado",
    notFoundDesc: "no esta en el catalogo.",
    backCatalog: "Volver al catalogo",
  },
  preImaging: {
    title: "Pre-Imagen",
    subtitle: "Anamnesis inicial para evaluacion WeTrust.",
    identification: "Identificacion",
    patientRecordLabel: "Numero de historia clinica",
    patientRecordPlaceholder: "ej. 2025-00123",
    anamnesis: "Anamnesis",
    ageLabel: "Edad",
    ageSuffix: "anios",
    nihssHint: "0-42",
    mrsLabel: "pre-mRS",
    mrsHint: "0 autonomo - 5 discapacidad severa",
    ltswLabel: "LTSW",
    ltswSuffix: "horas",
    ltswHint: "Horas desde ultima vez visto bien",
    wakeupTitle: "Wake-up stroke",
    wakeupLabel: "Wake-up stroke",
    wakeupDesc: "Para WeTrust: permite LTSW hasta 12h si los sintomas se identifican en 6h.",
    wakeupSymptomsLabel: "Sintomas identificados en 6h tras despertar",
    contextTitle: "Contexto operativo",
    angioLabel: "Angiografo Philips disponible?",
    doacLabel: "DOAC (NOAC) en las 48h previas?",
    aceiLabel: "Inhibidor ACE (IECA) en terapia?",
    rangeAge: "Edad entre 0 y 120",
    rangeNihss: "NIHSS entre 0 y 42",
    rangeMrs: "pre-mRS entre 0 y 5",
    rangeLtsw: "LTSW en horas (0-168)",
  },
  preResult: {
    title: "Resultado Pre-Imagen",
    weTrustEligible: "El paciente cumple los criterios WeTrust. Se puede proceder a randomizacion.",
    weTrustNotEligible: "El paciente no cumple todos los criterios WeTrust. Continuar con evaluacion post-imagen.",
    doacAlertTitle: "Paciente con DOAC (NOAC)",
    doacAlertDesc: "Realizar CTA toracica y niveles del farmaco.",
    randomize: "Randomizar",
    continue: "Continuar",
    weTrustEligibleAnnounce: "WeTrust elegible",
    weTrustNotEligibleAnnounce: "WeTrust no elegible",
  },
  postImaging: {
    title: "Post-Imagen",
    subtitle: "Tipo de ictus, candidatura y parametros.",
    strokeTypeStep: "Tipo ictus",
    detailsStep: "Detalles",
    confirmStep: "Confirmar",
    strokeTypeLabel: "Tipo de ictus",
    ischemic: "Isquemico",
    ischemicDesc: "LVO o no-LVO",
    hemorrhagic: "Hemorragico",
    hemorrhagicDesc: "HIC espontanea",
    candidacyTitle: "Candidatura para tratamiento",
    candidateEvt: "Candidato a trombectomia (EVT)?",
    candidateIvt: "Candidato a trombolisis (IVT)?",
    candidateEligible: "Elegible",
    candidateNotEligible: "No elegible",
    evtTitle: "Imagen EVT",
    evtDesc: "Requerido para ATHENA, PIVOTAL, MOSTE y otros ensayos EVT.",
    tandemLabel: "Oclusion tandem?",
    tortuosityLabel: "Tortuosidad vascular?",
    tortuosityHint: "Si no se especifica, algunos ensayos seran 'Not indicated'.",
    vesselsLabel: "Vaso objetivo",
    vesselsHint: "Selecciona uno o mas vasos ocluidos.",
    contraTpaLabel: "Contraindicaciones a la trombolisis?",
    aspectsLabel: "ASPECTS",
    aspectsHint: "0-10",
    nonEvtTitle: "Confirmacion isquemico no-EVT",
    lesionConfirmedLabel: "Lesion confirmada en imagen (CT / CTP / MRI)?",
    hemTitle: "Parametros hemorragicos",
    hemVolumeLabel: "Volumen hemorragia",
    hemVolumeSuffix: "mL",
    gcsLabel: "GCS",
    gcsHint: "3-15",
    ivhLabel: "Hemorragia aislada a IVH?",
    secondaryCauseLabel: "Causa secundaria",
    secondaryCauseNone: "Ninguna",
    seizureLabel: "Convulsiones / trombosis / hipersensibilidad a TXA?",
    anticoagLabel: "Terapia anticoagulante",
    anticoagNone: "Ninguna",
    fastestTitle: "FASTEST - Preguntas adicionales",
    fastestHint: "Solo se muestra si LTSW < 2h y pre-mRS <= 2.",
    brainstemLabel: "Hemorragia del tronco encefalico?",
    procoagulantLabel: "Farmacos procoagulantes en ultimas 24h?",
    ecgLabel: "Anomalias ECG?",
    thrombosisLabel: "Historia de trombosis aguda?",
    pregnancyLabel: "Embarazo?",
    angioplastyLabel: "Angioplastia reciente?",
    ivhScoreLabel: "IVH score conocido?",
  },
  summary: {
    title: "Ensayos elegibles",
    subtitle: "Selecciona uno o mas ensayos para proceder.",
    noneTitle: "Ningun ensayo elegible",
    noneDesc: "El paciente no cumple los criterios de ningun ensayo activo.",
    proceed: "Proceder al guardado",
    goToPostAcute: "Evaluar post-agudo (Librexia)",
    selectedCount: "seleccionados",
  },
  share: {
    title: "Guardar en Google Sheet",
    subtitle: "Revisa y envia el registro del paciente.",
    outcomeFor: "Outcome para",
    intervention: "Intervencion",
    control: "Control",
    notesLabel: "Notas",
    notesPlaceholder: "Notas libres...",
    messagePreview: "Vista previa del mensaje",
    copy: "Copiar",
    sendToSheet: "Enviar a Sheet",
    saveSuccess: "Guardado correctamente",
    saveError: "Error al guardar",
  },
  postAcute: {
    title: "Post-agudo (Librexia)",
    subtitle: "Evaluacion para ensayo post-agudo.",
    causeSuspectLabel: "Causa aterotrombotica sospechada?",
    persistentLabel: "Sintomas persistentes?",
    imagingFindingLabel: "Imagen consistente con etiologia aterotrombotica?",
    treatmentReceivedLabel: "Tratamiento recibido en fase aguda?",
    abcd2Label: "Puntaje ABCD2",
    abcd2Hint: "0-7",
    labsTitle: "Valores de laboratorio",
    inrLabel: "INR",
    apttLabel: "aPTT ratio",
    gfrLabel: "TFG",
    chronicAnticoagLabel: "Anticoagulacion cronica en curso?",
    hepaticLabel: "Enfermedad hepatica?",
    pregnancyLabel: "Embarazo?",
    eligibleTitle: "Librexia elegible",
    notEligibleTitle: "Librexia no elegible",
  },
  trialPatient: {
    title: "Paciente desde ensayo",
    subtitle: "Entrada rapida para reclutamiento ya decidido.",
    selectedTrialLabel: "Ensayo seleccionado",
    armLabel: "Brazo",
    otherTrialsLabel: "Otros ensayos asociados",
    addTrial: "Anadir ensayo",
    targetVesselLabel: "Vaso objetivo",
    acuteTreatmentsLabel: "Tratamientos agudos",
    tevLabel: "Trombectomia (TEV)?",
    mticiLabel: "mTICI",
    tivLabel: "Trombolisis (IVT)?",
  },
  extras: {
    show: "Mostrar",
    hide: "Ocultar",
    review: "Revision",
    continueWithoutSelection: "Continuar sin seleccion",
    criteriaMissing: "Criterios faltantes",
    proceedHow: "Como quieres proceder?",
    sinceLtsw: "desde LTSW",
    activeSession: "Paciente en curso",
    severity: "Severidad",
    patternCause: "Patron y causa",
    eligFactors: "Factores de elegibilidad",
    isolatedIvh: "Hemorragia aislada IVH",
    isolatedIvhSub: "Hemorragia confinada al sistema ventricular",
    txaExcl: "Exclusion TXA",
    txaExclSub: "Convulsiones / trombosis / hipersensibilidad a TXA",
    acuteTreatments: "Tratamientos agudos",
    noEligibleTitle: "Ningun ensayo elegible",
    noEligibleDesc: "El paciente no cumple los criterios de ningun ensayo activo.",
    windowIv: "Ventana trombolisis IV",
    windowEvt: "Ventana EVT estandar",
    windowEvtSelected: "Ventana EVT seleccionada (<=24h)",
    windowClosed: "Ventana cerrada",
    symptomsWithin6h: "Sintomas en 6h",
    eligibleTrialsCount: "ensayos elegibles",
    results: "Resultados",
    selectDateTime: "Selecciona fecha y hora",
    setTime: "Establecer",
    nowL: "Ahora",
    tabPatients: "Pacientes",
    tabStats: "Estadisticas",
    statScreened: "Screened",
    statEnrolled: "Enrolled",
    statRate: "Rate",
    statIschemic: "Isquemico",
    statHemorrhagic: "Hemorragico",
    statEnrollmentsByTrial: "Reclutamientos por ensayo",
    statNoData: "Aun no hay datos disponibles.",
    savedEmpty: "Ningun paciente guardado todavia.",
    savedSubtitle: "Historico local - tap para reabrir",
    savedRemoveConfirm: "Eliminar",
    senza: "(sin ID)",
    age: "Edad",
    volumeTitle: "Volumen hemorragia",
    notAvailable: "No disponible",
    volPending: "Volumen por definir",
    largeHematoma: "Hematoma extenso (>=30 mL)",
    dragVolume: "Arrastra o toca el circulo",
    gcsSevere: "Severo",
    gcsModerate: "Moderado",
    gcsMild: "Leve",
    coreLarge: "Core extenso",
    coreModerate: "Core moderado",
    coreFavorable: "Core favorable",
    vesselsNone: "Ningun vaso seleccionado",
    ichScore: "ICH Score",
    mortality30: "Mortalidad a 30d:",
    volPendingScore: "Volumen pendiente - score parcial",
    catalog: "Catalogo",
    fastTag: "Rapido",
    guidedTag: "Guiado",
    directEnroll: "Reclutamiento directo",
    directEnrollDesc: "Entrada rapida para paciente ya decidido",
    skipToContent: "Ir al contenido",
    causeNone: "Ninguna",
    causeTrauma: "Trauma",
    causeAVM: "AVM",
    causeAneurysm: "Aneurisma",
    causeTumor: "Tumor",
    causeOther: "Otra",
    anticoagHep: "Heparina <24h",
    regionPosterior: "Posterior",
    quickSubtitle: "Entrada rapida sin evaluacion de elegibilidad.",
    quickTrialLabel: "Ensayo asignado",
    quickTrialPlaceholder: "Selecciona un ensayo...",
    quickArmLabel: "Brazo",
    quickIntervention: "Intervencion",
    quickControl: "Control",
    sendDirect: "Enviar directamente",
    sentSuccess: "Enviado",
    goHome: "Ir al inicio",
    trialsEnrolled: "Ensayos reclutados",
    trialsEligibleNotEnrolled: "Elegibles no reclutados",
    edit: "Editar",
    deleteAction: "Eliminar",
    notFound: "No encontrado",
    notInLocalArchive: "Paciente no en el archivo local",
    syncToFetch: "Sincroniza la lista para descargar el paciente del Sheet.",
    missedShort: "missed",
    cloudPill: "cloud",
  },
};
